import React from 'react';
import { CaseStudyToggle } from './CaseStudyToggle';
import { scenarios, workHeading, workIntro } from '../../data/scenarios';
import { textures } from '../../data/site';
export function WorkSection() {
  return <section id="work" aria-labelledby="work-title" className="scroll-mt-16 md:scroll-mt-[72px]" data-id="element-124" data-mp="i300kqcarkom">
      {/* Ink wash band. The statement sits on a Paper plate that overlaps it, never directly on the paint. */}
      <div className="relative" data-id="element-125" data-mp="1arxgimt1d5e7">
        <img src={textures.wash} alt="" aria-hidden="true" loading="lazy" decoding="async" className="absolute inset-0 block h-full w-full object-cover" data-id="element-126" data-mp="1aoru5fbskhm6" />
        <div className="relative mx-auto max-w-page px-6 pt-[140px] sm:pt-[190px] md:px-12 md:pt-[240px] lg:pt-[270px] xl:px-20" data-id="element-127" data-mp="15r9j9je7rsbj">
          <div className="grain relative bg-paper px-6 pb-8 pt-8 sm:px-10 sm:pb-10 sm:pt-10 md:max-w-[760px] md:px-12 md:pb-12 md:pt-12" data-id="element-128" data-mp="3lhmdlibiqj4t">
            <p className="max-w-[30ch] font-display text-[26px] font-light leading-[1.3] text-graphite md:text-[34px] md:leading-[1.25]" data-id="element-129" data-mp="3qfnv3ytaqae6">
              {workIntro}
            </p>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-page px-6 pb-24 pt-16 md:px-12 md:pb-32 md:pt-24 xl:px-20" data-id="element-130" data-mp="25156pa6nq3ko">
        <h2 id="work-title" className="border-t border-ink pt-8 font-display text-[34px] font-light leading-[1.12] tracking-[-0.01em] text-graphite md:mt-24 md:pt-10 md:text-[48px]" data-id="element-131" data-mp="202burm70qkmm">
          {workHeading}
        </h2>

        <ul role="list" className="mt-4 md:mt-8" data-id="element-132" data-mp="29zq4l2yfsb5y">
          {scenarios.map(s => <li key={s.id} className="grid gap-6 border-b border-fog py-12 md:py-16 lg:grid-cols-12 lg:gap-8" data-id="element-133" data-mp="2nqv0btyoojb0">
              <h3 className="max-w-[18ch] font-display text-[26px] leading-[1.2] text-graphite md:text-[32px] lg:col-span-5" data-id="element-134" data-mp="2itd0qu6k3gfo">
                {s.title}
              </h3>
              <div className="lg:col-span-7" data-id="element-135" data-mp="2srshc37yj7ax">
                <p className="max-w-[60ch] text-[17px] leading-[1.65] text-ink" data-id="element-136" data-mp="2sowi8bkdickw">{s.description}</p>
                <div className="mt-8" data-id="element-137" data-mp="2zs4ewzc6y0pc">
                  <p id={`${s.id}-caps`} className="pt-[2px] font-mark text-[12px] uppercase leading-none tracking-label text-ridge" data-id="element-138" data-mp="34sr26fxe0s1q">
                    Our Capabilities
                  </p>
                  <ul role="list" aria-labelledby={`${s.id}-caps`} className="mt-4 flex flex-wrap gap-2" data-id="element-139" data-mp="3eitusf0lk3zj">
                    {s.capabilities.map(c => <li key={c} className="border border-fog bg-birch px-3 py-2 text-[14px] leading-none text-ink" data-id="element-140" data-mp="3jhx102sbcg93">
                        {c}
                      </li>)}
                  </ul>
                </div>
                <CaseStudyToggle label={s.toggleLabel} facts={s.facts} body={s.caseStudy} data-id="element-141" data-mp="1cbmejqobtit" />
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}